// https://cmsdev.cruisecode.com/BookingPlatform/GetGuides?cuid=72aca93d-62a8-48e8-abf5-9814dc7604ae&isActive=true

export const GetGuides = [
    {
        GuideId: 7,
        UserId: '012a46f8-d10d-46a6-9967-9eb77196af4a',
        TransportationId: 1,
        TransportationName: 'Bus 1',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Alexis Applegate',
        GuideFullNameText: 'Alexis Applegate - Bus 1 25 pass',
        GuideText: 'Alexis - Bus 1 25 pass',
        GuideText30: 'Alexis - Bus 1 25 pass',
        Capacity: 25,
    },
    {
        GuideId: 6,
        UserId: '405817bf-576d-4d3a-a8c1-ca49878a643b',
        TransportationId: 1,
        TransportationName: 'Bus 1',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Alkesh Patel',
        GuideFullNameText: 'Alkesh Patel - Bus 1 25 pass',
        GuideText: 'Alkesh - Bus 1 25 pass',
        GuideText30: 'Alkesh - Bus 1 25 pass',
        Capacity: 25,
    },
    {
        GuideId: 9,
        UserId: '469d47c4-8b95-4bd3-87a2-4afa8c656cef',
        TransportationId: 2,
        TransportationName: 'Sightseeing Plane N567AK',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Ashley Caulk',
        GuideFullNameText: 'Ashley Caulk - Sightseeing Plane N567AK 12 pass',
        GuideText: 'Ashley - Sightseeing Plane N567AK 12 pass',
        GuideText30: 'Ashley - Sightseeing Plane N56',
        Capacity: 12,
    },
    {
        GuideId: 8,
        UserId: '609e71c8-ba3b-4495-958b-24633f950a45',
        TransportationId: 1,
        TransportationName: 'Bus 1',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Austin Bricker',
        GuideFullNameText: 'Austin Bricker - Bus 1 25 pass',
        GuideText: 'Austin - Bus 1 25 pass',
        GuideText30: 'Austin - Bus 1 25 pass',
        Capacity: 25,
    },
    {
        GuideId: 5,
        UserId: '5648e28f-b425-47b4-a412-c065437508de',
        TransportationId: null,
        TransportationName: null,
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Axel  Carrasquillo',
        GuideFullNameText: 'Axel  Carrasquillo',
        GuideText: 'Axel ',
        GuideText30: 'Axel ',
        Capacity: null,
    },
    {
        GuideId: 1,
        UserId: '04dad7c7-b0a3-4c67-9c01-ac3d4cf879df',
        TransportationId: 1,
        TransportationName: 'Bus 1',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Denise Chocholusek',
        GuideFullNameText: 'Denise Chocholusek - Bus 1 25 pass',
        GuideText: 'Denise - Bus 1 25 pass',
        GuideText30: 'Denise - Bus 1 25 pass',
        Capacity: 25,
    },
    {
        GuideId: 3,
        UserId: '3881b3b6-b91f-4838-a71b-72c356c4d40c',
        TransportationId: 2,
        TransportationName: 'Sightseeing Plane N567AK',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Garrett Newman',
        GuideFullNameText: 'Garrett Newman - Sightseeing Plane N567AK 12 pass',
        GuideText: 'Garrett - Sightseeing Plane N567AK 12 pass',
        GuideText30: 'Garrett - Sightseeing Plane N5',
        Capacity: 12,
    },
    {
        GuideId: 4,
        UserId: '4a33141a-0613-4d3c-a814-7aa4f2f53a69',
        TransportationId: null,
        TransportationName: null,
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Jason Smith',
        GuideFullNameText: 'Jason Smith',
        GuideText: 'Jason',
        GuideText30: 'Jason',
        Capacity: null,
    },
    {
        GuideId: 2,
        UserId: '060e2cc3-45fd-4c35-ac0e-c14668a33a5d',
        TransportationId: 2,
        TransportationName: 'Sightseeing Plane N567AK',
        IsActive: true,
        CompanyUniqueID: '00000000-0000-0000-0000-000000000000',
        GuideFullName: 'Patrick  Barker',
        GuideFullNameText: 'Patrick  Barker - Sightseeing Plane N567AK 12 pass',
        GuideText: 'Patrick  - Sightseeing Plane N567AK 12 pass',
        GuideText30: 'Patrick  - Sightseeing Plane N',
        Capacity: 12,
    },
];
